import React, { createContext, useContext } from 'react';

import { useApplicationContext } from '@/context/v1/Application/context';

import type { FileForCustomReport } from '@/components/ui/Inputs/types/response/file';
import type { BeraJobSummary } from '@/types/Bera';
import type { Context, State } from './types';

interface BeraJobSummaryResultProviderProps {
	file: FileForCustomReport;
	jobSummary: BeraJobSummary;
	children: JSX.Element;
}

const BeraJobSummaryResultContext = createContext<Context | undefined>(undefined);

export function BeraJobSummaryResultProvider({
	file,
	jobSummary,
	children
}: Readonly<BeraJobSummaryResultProviderProps>): JSX.Element {
	const { organization, company } = useApplicationContext();

	const organizationId = organization?.id ?? '';
	const companyId = company?.id ?? '';

	const states: State = {
		file,
		jobSummary,
		organizationId,
		companyId
	};

	const context: Context = { ...states };

	return <BeraJobSummaryResultContext.Provider value={context}>{children}</BeraJobSummaryResultContext.Provider>;
}

export function useBeraJobSummaryResult(): Context {
	const context = useContext(BeraJobSummaryResultContext);

	if (!context) {
		throw new Error('useBeraJobSummaryResult must be used within a BeraJobSummaryResultProvider');
	}

	return context;
}
